import { SURVEY_EDIT_LOAD, SURVEY_EDIT_UNLOAD, SURVEY_LIST_LOAD, SURVEY_LIST_UNLOAD } from "../../actions/Constants";

const INITIAL_STATE = { 
  survey: null, 
  editLoad: false,
  surveys: [],
  listLoad: false
};

export default function surveyEdit(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SURVEY_EDIT_LOAD:
      return {
        ...state,
        survey: action.payload || null,
        editLoad: true,
      };
    case SURVEY_EDIT_UNLOAD:
      return {
        ...state,
        survey: null,
        editLoad: false,
      };
    case SURVEY_LIST_LOAD:
      return {
        ...state,
        surveys: action.payload || [],
        listLoad: true,
      };
    case SURVEY_LIST_UNLOAD:
      return {
        ...state,
        surveys: [],
        listLoad: false,
      };
    default:
      return state;
  }
}
